<template>
  <div id="app">
    <v-app>
      <!-- Main -->
      <template v-if="$store.state.init">
        <core-toolbar />
        <core-drawer />
        <core-view />
        <core-footer />
        <core-notification-snackbar />
        <core-login-register-dialog />
      </template>

      <!-- Loading Overlay -->
      <v-row
        v-else
        align="center"
        justify="center"
        class="v-overlay"
        style="position: absolute;"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-row>
    </v-app>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  computed: {
       ...mapFields('user', ['user']),

    },
    mounted(){
      Promise.all([this.$store.dispatch('user/loadUser')])
.then(()=>{
  if (!this.$store.state.user.isSubscriber){
    window.InvestingChannelQueue = window.InvestingChannelQueue || [];
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://u5.investingchannel.com/static/uat.js')
    document.head.appendChild(externalScript)
    var page;
        window.InvestingChannelQueue.push(function() {
            page = window.InvestingChannel.UAT.Run("eb033e36-f527-46c7-b805-92c1fb0f90cc");
        });
  }
  else{
    window.InvestingChannelQueue = window.InvestingChannelQueue || [];
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://u5.investingchannel.com/static/uat.js')
    document.head.appendChild(externalScript)
    var ic_page;
window.InvestingChannelQueue.push(function() {
ic_page = window.InvestingChannel.UAT.Run("85b226af-2348-429a-8838-8e22eea88d78",{"show_no_ads":true});
});
  }
})
    }
}
</script>

<style lang="scss">
@import '~@vars';
@import '~@/assets/style/main';

#nprogress .bar {
  background: $primary;
}

// MD2 spec has a weird design for mobile tabs that causes them to appear left padded on mobile
.v-slide-group__prev.v-slide-group__prev--disabled {
  display: none !important;
}
</style>
